import ProductsCategories from './ProductsCategories';

export default ProductsCategories;